module.exports = __webpack_public_path__ + "static/media/loc.85fd34f2.svg";